import { Capacitor } from "@capacitor/core";

// True uniquement dans la coquille native (iOS/Android), false sur le web/PWA.
export function isNative() {
  return Capacitor.isNativePlatform();
}

// Initialise les intégrations natives. No-op sur le web : la PWA n'est pas
// affectée. Les plugins sont importés dynamiquement pour ne pas charger le
// code natif dans le bundle web.
export async function initNative() {
  if (!isNative()) return;

  const [{ StatusBar, Style }, { SplashScreen }, { App }, { Keyboard }] =
    await Promise.all([
      import("@capacitor/status-bar"),
      import("@capacitor/splash-screen"),
      import("@capacitor/app"),
      import("@capacitor/keyboard"),
    ]);

  // Socle 2026-08 : la barre d'état suit le thème réel de l'app. L'ancien
  // réglage figé (texte clair + fond #060607) rendait l'heure et la batterie
  // invisibles en thème clair — constaté sur iOS et Android en QA du 15/08.
  const appliquerBarreEtat = async () => {
    const sombre = document.documentElement.classList.contains("dark");
    try {
      // Style.Dark = texte clair (pour fond sombre) ; Style.Light = texte sombre.
      await StatusBar.setStyle({ style: sombre ? Style.Dark : Style.Light });
      if (Capacitor.getPlatform() === "android") {
        await StatusBar.setBackgroundColor({ color: sombre ? "#060607" : "#F6F6F4" });
      }
    } catch { /* plateforme sans status bar réglable : on ignore */ }
  };
  await appliquerBarreEtat();
  // Suit les bascules de thème (toggle utilisateur ou préférence système).
  new MutationObserver(appliquerBarreEtat).observe(document.documentElement, {
    attributes: true, attributeFilter: ["class"],
  });

  // Bouton retour Android : remonter l'historique, sinon mettre l'app en fond.
  App.addListener("backButton", ({ canGoBack }) => {
    if (canGoBack) window.history.back();
    else App.exitApp();
  });

  try {
    await Keyboard.setResizeMode({ mode: "native" });
  } catch { /* noop */ }

  // Expose la hauteur du clavier en variable CSS (--kb) pour que les footers
  // collants remontent au-dessus du clavier au lieu d'être masqués.
  const root = document.documentElement;
  Keyboard.addListener("keyboardWillShow", (info) => {
    root.style.setProperty("--kb", `${info.keyboardHeight || 0}px`);
  });
  Keyboard.addListener("keyboardWillHide", () => {
    root.style.setProperty("--kb", "0px");
  });

  // Masque le splash une fois l'app montée.
  setTimeout(() => SplashScreen.hide().catch(() => {}), 300);
}
